/**
 * RTB House 이벤트 전송
 * @see {@link https://docs.google.com/spreadsheets/d/1XJ2-sOkp4IXiojAkX2SXXegTPHUU2iQxXrwRlTeeMa4/edit?gid=141099364#gid=141099364}
 * */

export type RtbHouseEvent = Record<string, unknown>

type WindowWithRtbHouse = Window & {
  rtbhEvents?: Record<string, unknown>[]
}

export const RTB_HOUSE_SCRIPT = `(function (w,d,dn,t){w[dn]=w[dn]||[];w[dn].push({eventType:'init',value:t,dc:''});var f=d.getElementsByTagName('script')[0],c=d.createElement('script');c.async=true;c.src='https://tags.creativecdn.com/uWJZAcXe17p7uN9IHO2A.js';f.parentNode.insertBefore(c,f);})(window,document,'rtbhEvents','uWJZAcXe17p7uN9IHO2A');`

export const sendRtbEvent = (...entries: RtbHouseEvent[]) => {
  if (typeof window === 'undefined') return
  const w = window as WindowWithRtbHouse
  if (!w.rtbhEvents) {
    w.rtbhEvents = []
  }
  w.rtbhEvents.push(...entries)
}
